import React, { useEffect } from 'react';
import { OptionTypeBase, Select as MuiSelect } from '@beeline.com/bp-design-system';

interface MultiSelectProps {
  className?: string;
  clearable?: boolean;
  name?: string;
  onChange(value: OptionTypeBase[] | null): void;
  open?: boolean;
  options: OptionTypeBase[] | readonly OptionTypeBase[];
  placeholder?: string;
  style?: React.CSSProperties;
  value: OptionTypeBase[] | null | undefined;
  sort?: boolean;
}

export const MultiSelect = ({
  className,
  clearable,
  name,
  onChange,
  open,
  options,
  placeholder,
  style,
  value,
  sort
}: MultiSelectProps) => {
  const [selected, setSelected] = React.useState<OptionTypeBase[] | undefined>(value ?? undefined);
  const refSelected = React.useRef(selected);

  // Since the component unmounts when clicking outside, we trigger the onChange callback
  // in the useEffect cleanup function to simulate an onBlur behavior
  useEffect(() => {
    return () => {
      onChange(refSelected.current ?? null);
    };
  }, [onChange]);
  return (
    <MuiSelect<string, true>
      multiple
      className={className}
      disableClearable={!clearable}
      dataTest={`multi-select-field${name ? `-${name}` : ''}`}
      id={name ? `multi-select-field-${name}` : undefined}
      name={name}
      menuProps={{
        hideSelectedOptions: false,
        openOnStart: open,
        sort: sort ?? true
      }}
      listBoxProps={{ scrollSelectedItemIntoView: true }}
      onOptionChange={(nextOptions) => {
        setSelected(nextOptions);
        return (refSelected.current = nextOptions);
      }}
      options={options as OptionTypeBase[]}
      chipProps={{
        limit: {
          count: 1,
          permanent: true
        }
      }}
      placeholder={placeholder}
      style={style}
      valueOptions={selected}
    />
  );
};
